<template>
    <div :class="{featurebuttonbg:true, featurebuttonbgscroll:featurebuttonbgscroll_flag}">
        <div class="mailbutton" @click="clickbutton">
            <img src="https://p3.udn.com.tw/wish/images/common/button_mail_gray.svg" />
        </div>
        <div :class="{heartbutton: true, heartbuttonclick: flag}" @click="clickheart">
            <div :class="{heartnum:true, grow:this.$store.state.heartnum>99}">
                {{this.$store.state.heartnum}}
            </div>
            <img src="https://p3.udn.com.tw/wish/images/common/button_love_gray.svg" />
        </div>
    </div>
</template>
  
<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    import axios from 'axios';
    export default {
        mixins: [sendGaMethods],
        data(){
            return{
                featurebuttonbgscroll_flag:false,
                flag: false,
                
            }
        },
        created () {
            window.addEventListener('scroll', this.onScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.onScroll);
        },
        mounted(){
        },

        methods:{
            onScroll(e){
                if(pageYOffset>=document.getElementById("voicepartbg").offsetTop-window.innerHeight || document.getElementById("firstpartbg").getBoundingClientRect().top>0) this.featurebuttonbgscroll_flag=false;
                else this.featurebuttonbgscroll_flag=true;

            },
            clickbutton(){
                window.open("https://docs.google.com/forms/d/e/1FAIpQLScA49vvk8CUnFsAxK7OqXZ9XBbP8sQ_-a0l9UuB0_WZGzp4mQ/viewform", '_blank');
                this.sendGA({category: 'widget_+1', action: 'click', label: "click_widget_+1_"+this.$store.state.currentwisher});
            },
            clickheart(){
                // JSON.stringify({ flag: 'Udn70Wish', title: this.$store.state.currentwisher })
                this.flag=true;
                this.$store.state.heartflag=true;
                let bodyFormData = new FormData();
                bodyFormData.append('flag',"Udn70Wish");
                bodyFormData.append('title', this.$store.state.currentwisher);
                axios
                .post("https://newmedia.udn.com.tw/active/api/message/", { flag: 'Udn70Wish', title: this.$store.state.currentwisher })
                .then((jsonData) => {
                    this.$store.state.heartnum=jsonData.data["data"][0]["userlike"];
                })
                .catch((err) => {
                    console.log("錯誤:", err);
                });

                this.sendGA({category: 'widget_heart', action: 'click', label: "click_widget_heart_"+this.$store.state.currentwisher});
            }
        }
    };
</script>

<style lang="scss" scoped>
    .featurebuttonbg{
        position: fixed;
        bottom: 30px;
        right: -300px;
        display: flex;
        flex-direction: row;
        transition: right .5s;
        .mailbutton{
            position: relative;
            margin-right: 10px;
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            box-shadow: 0px 0px 15px rgb(0, 0, 0, 0.2);
            img{
                width: 40%;
                height: 40%;
            }
        }
        @media (hover: hover) {
            .mailbutton:hover{
                img{
                    content: url('https://p3.udn.com.tw/wish/images/common/button_mail_golden.svg');
                }
            }
        }
        .heartbutton{
            position: relative;
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            box-shadow: 0px 0px 15px rgb(0, 0, 0, 0.2);
            .heartnum{
                position: absolute;
                top: -12px;
                right: -3px;
                min-width: 26px;
                min-height: 26px;
                padding: 5px;
                border-radius: 50%;
                font-size: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #FFFFFF;
                background-color: #A08E33;
            }
            .grow{
                border-radius: 11px;
            }
            img{
                width: 40%;
                height: 40%;
            }
        }
        .heartbuttonclick{
            img{
                content: url('https://p3.udn.com.tw/wish/images/common/button_love_golden.svg');
            }
        }
        @media (hover: hover) {
            .heartbutton:hover{
                img{
                    content: url('https://p3.udn.com.tw/wish/images/common/button_love_golden.svg');
                }
            }
        }
    }
    .featurebuttonbgscroll{
        right: 16px;
    }
</style>